import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { Badge } from 'foundations-components/transitional/components/Badge';
import { Button } from 'foundations-components/transitional/components/Button';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { FeatureDisplayChecklistItem } from 'pricing-pages-ui-components/components/merch-card/feature-display/FeatureDisplayChecklistItem';
import MerchCardLayout from 'pricing-pages-ui-components/layouts/merch-cards/MerchCardLayout';
import { PricePerMonth } from 'pricing-pages-ui-components/price/PricePerMonth';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const CARD_STYLES = {
  paddingInline: '600',
  backgroundColor: 'fill-surface-default',
  borderRadius: '400',
  borderStyle: 'solid',
  borderColor: 'border-core-subtle',
  borderWidth: '100'
};
const BADGE_USE = {
  recommended: 'sorbet',
  current: 'koala'
};
const BADGE_LABELS = {
  recommended: 'hsocPricingPage.badge.recommended',
  current: 'hsocPricingPage.badge.current'
};
export const HsocMerchCard = ({
  columnStart,
  tierApiName,
  title,
  subheading,
  price,
  features,
  ctas,
  badge
}) => {
  var _price$showPerSeat;
  const BadgePill = badge ? /*#__PURE__*/_jsx(Badge, {
    use: BADGE_USE[badge],
    alignSelf: "center",
    children: /*#__PURE__*/_jsx(Text, {
      as: "span",
      typography: "heading-25",
      textWrap: "nowrap",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: BADGE_LABELS[badge]
      })
    })
  }) : null;
  const Title = /*#__PURE__*/_jsx(View, {
    paddingBlockStart: "600",
    children: /*#__PURE__*/_jsxs(Flex, {
      justifyContent: "space-between",
      alignItems: "center",
      gap: "300",
      children: [/*#__PURE__*/_jsx(Text, {
        as: "h2",
        typography: "heading-400",
        marginBlockStart: "0",
        children: title
      }), BadgePill]
    })
  });
  const Subheading = /*#__PURE__*/_jsx(View, {
    paddingBlockStart: "50",
    children: /*#__PURE__*/_jsx(Text, {
      as: "p",
      typography: "body-100",
      color: "text-core-subtle",
      children: subheading
    })
  });
  const Pricing = /*#__PURE__*/_jsxs(View, {
    paddingBlockStart: "400",
    children: [price ?
    /*#__PURE__*/
    /* TODO(#21690): revisit price shape once CHIRP data source is known —
     * card may need separate annualPrice/monthlyPrice fields to support the
     * term toggle, and PriceDisplayWithTerm may be more appropriate if the
     * RPC response includes a PricingInfo-equivalent object. */
    _jsx(Text, {
      typography: "heading-600",
      children: /*#__PURE__*/_jsx(PricePerMonth, {
        price: price.price,
        currencyCode: price.currencyCode,
        showPricePerMonthPerSeat: (_price$showPerSeat = price.showPerSeat) !== null && _price$showPerSeat !== void 0 ? _price$showPerSeat : false,
        seleniumId: `${tierApiName}-price`
      })
    }) : null, price !== null && price !== void 0 && price.includedSeats ? /*#__PURE__*/_jsx(Text, {
      as: "p",
      typography: "body-200",
      color: "text-core-subtle",
      marginBlockStart: "100",
      children: price.includedSeats
    }) : null]
  });
  const CTAs = /*#__PURE__*/_jsx(Flex, {
    paddingBlockStart: "500",
    gap: "200",
    children: ctas.map((cta, index) => {
      var _cta$use;
      return /*#__PURE__*/_jsx(View, {
        inlineSize: "100%",
        overflow: "hidden",
        children: /*#__PURE__*/_jsx(Button, {
          use: (_cta$use = cta.use) !== null && _cta$use !== void 0 ? _cta$use : index === 0 ? 'primary' : 'secondary',
          size: "md",
          onClick: cta.onClick,
          children: cta.label
        })
      }, cta.label);
    })
  });
  const Features = /*#__PURE__*/_jsx(View, {
    paddingBlockStart: "600",
    paddingBlockEnd: "600",
    children: features.map(feature => /*#__PURE__*/_jsx(View, {
      paddingBlockEnd: "200",
      children: /*#__PURE__*/_jsx(FeatureDisplayChecklistItem, {
        message: feature.label,
        isAvailable: feature.isAvailable !== false
      })
    }, feature.key))
  });
  return /*#__PURE__*/_jsx(MerchCardLayout, {
    "data-selenium-id": `${tierApiName}-merch-card`,
    columnStart: columnStart,
    Title: Title,
    Subheading: Subheading,
    Pricing: Pricing,
    CTAs: CTAs,
    Features: Features,
    cardStyles: CARD_STYLES
  });
};